import ExcelJS from "exceljs";
import { getProductPrice } from "utils/cartUtils";

// Columns emitted for the Rutronik order sheet.
const COLUMNS = [
  { header: "Part Number", key: "part_number", width: 24 },
  { header: "Rutronik SKU", key: "rutronik_sku", width: 20 },
  { header: "Manufacturer", key: "manufacturer", width: 22 },
  { header: "Description", key: "description", width: 48 },
  { header: "Quantity", key: "qty", width: 12 },
  { header: "Unit Price", key: "unit_price", width: 14 },
  { header: "Total Price", key: "total_price", width: 14 },
  { header: "Availability", key: "availability", width: 14 },
];

const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
};

// Build an in-memory .xlsx of the selected Rutronik line items and return
// { base64, fileName, rows } for emailing + previewing.
export const buildRutronikOrderExcel = async (cartItems = [], { orderReference } = {}) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Semisearch";
  const sheet = workbook.addWorksheet("Rutronik Order");

  sheet.columns = COLUMNS;

  // Header styling.
  const headerRow = sheet.getRow(1);
  headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
  headerRow.eachCell((cell) => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF00509E" } };
    cell.alignment = { vertical: "middle", horizontal: "left" };
  });

  const rows = cartItems.map((item) => {
    const qty = parseInt(item.required_qty, 10) || 0;
    const unitPrice = Number(getProductPrice(item)) || 0;
    return {
      part_number: item.part_number || "",
      rutronik_sku: item.api_partner_part_number || "",
      manufacturer: item.manufacturer || "",
      description: item.description || "",
      qty,
      unit_price: unitPrice,
      total_price: Number((qty * unitPrice).toFixed(2)),
      availability: Number(item.availability) || 0,
    };
  });

  rows.forEach((r) => sheet.addRow(r));

  // Totals row.
  const totalQty = rows.reduce((a, r) => a + r.qty, 0);
  const grandTotal = rows.reduce((a, r) => a + r.total_price, 0);
  const totalRow = sheet.addRow({
    part_number: "TOTAL",
    qty: totalQty,
    total_price: Number(grandTotal.toFixed(2)),
  });
  totalRow.font = { bold: true };

  const buffer = await workbook.xlsx.writeBuffer();
  const fileName = `${orderReference || "rutronik-order"}.xlsx`;

  return { base64: arrayBufferToBase64(buffer), fileName, rows, totalQty, grandTotal };
};
